//import { forEach } from "async";

export default () => {
    const $header = $('header');
    const headerRows = document.querySelectorAll('.mdl-layout__header-row');
    const inCommunities = !!document.querySelector('.mdl-navigation__link--active[href="/communities"]');
    const inLivingChoices = !!document.querySelector('.mdl-navigation__link--active[href="/living-choices"]');
    const noCollapse = $header.hasClass('no-collapse');

    // Collapse corporate navigation bar
    if ((inCommunities || inLivingChoices) && headerRows.length > 1 && !noCollapse) {
        $(window).scroll(function () {
            if ($(window).scrollTop() >= 200) {
                $header.addClass('scrolled');
            } else if ($(window).scrollTop() < 100) {
                $header.removeClass('scrolled');
            }
        });
    }

    
    //calculate how big the visible menu is and then set the padding. will need to redo on resize of viewport, the scroll to top might become annoying.
    var visibleMenuHeight = 0;
    const $content = $('.mdl-layout__content');
    //$(window).resize(calculateHeight);
    calculateHeight();
    
    function calculateHeight() {
        visibleMenuHeight = 0;
        headerRows.forEach(sumHeights);
        $content.css('padding-top', visibleMenuHeight);
    }

    function sumHeights(menuItem) {
        visibleMenuHeight += menuItem.clientHeight;
    }
};